import { render, staticRenderFns } from "./studentBillDetailWx.vue?vue&type=template&id=4f404d8c&scoped=true"
import script from "./studentBillDetailWx.vue?vue&type=script&lang=js"
export * from "./studentBillDetailWx.vue?vue&type=script&lang=js"
import style0 from "./studentBillDetailWx.vue?vue&type=style&index=0&id=4f404d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f404d8c",
  null
  
)

export default component.exports